import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, {useState} from 'react'
import Form from 'react-bootstrap/Form';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import Select from '../../components/Select';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../../components/TextInput';
import Checkbox from '../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../components/Checkbox/CheckboxGroup';
import {getAllCases} from '../../services/cases';
import CaseFormModal from '../../components/Case/CaseFormModal';
import useModal from '../../hooks/useModal';
import GenericCard from '../../components/GenericCards/GenericCards';
import PopoverWithLinks, { LinkData } from '../widgets/PopoverLinks/PopoverLinks';
import Link from '../../components/Link';
interface Cases {
  id: number;
  participant: string;
  recordStatus: string;
  doc: string;
  details: string;
  inbox: string;
  plan: string;
  recordNo: string;
  date: string;
}

const CaseList = () => {
  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    getValues
  } = useForm({});

  const [showAddNewCaseModal, handleAddNewCaseShow, handleAddNewCaseClose] = useModal();
  const [isSearchResultVisible, setIsSearchResultVisible] = useState(false);
  const [filteredCaseList, setFilteredCaseList] = useState<Cases[]>([]);

  const handleSearchButtonClick = () => {
    const { Name, Inbox } = getValues(); // Get the search term from the form field

    if (!Name && !Inbox) {
      // If search term is empty, display the full case list
      setFilteredCaseList(caseList);
      setIsSearchResultVisible(true);
    } else {
      // Filter the list based on the search term (both firstName and lastName)
      const filteredList = caseList.filter((cases: Cases) => {
        // Check if Name matches any part of the participant's name
        const nameMatches = !Name || Name.toLowerCase().split(" ").some((term: string) =>
          (cases.participant.toLowerCase().includes(term))
        );

        const inboxMatches = !Inbox || Inbox.toLowerCase().split(" ").some((term: string) =>
          (cases.inbox.toLowerCase().includes(term))
        );

        return nameMatches && inboxMatches;
      })
      setFilteredCaseList(filteredList);
      setIsSearchResultVisible(true);
    }
  };

  const handleResetButtonClick = () => {
    reset(); // Reset all form inputs
    setValue('SSN', '');
    setValue('EID', '');
    setValue('Name', '');
    setValue('AccessID', '');
    setValue('Inbox', null);
    setValue('with-labels', false);
    setIsSearchResultVisible(false);
    var selectInputCustom = document.querySelector('.select-input-custom');
    if (selectInputCustom) {
      var dropdownButton = selectInputCustom.querySelector('.dropdown-toggle');

      // Reset the dropdown button text and classes
      if (dropdownButton) {
        dropdownButton.textContent = 'Inbox';
        dropdownButton.classList.remove('selected', 'selected-primary');
        dropdownButton.classList.add('form-control-primary');
      }
    }
  };

  const inboxOptions = [
    { label: 'Smith, Alex', value: 'Smith, Alex' },
    { label: 'Millans, Tom', value: 'Millans, Tom' },
    { label: 'Jones, Pat', value: 'Jones, Pat' },
    { label: 'Smith, Morgan', value: 'Smith, Morgan' },
    { label: 'Jones, Cameron', value: 'Jones, Cameron' },
  ];

  const caseList = getAllCases();

  const handleSubmitCase = (formData: any) => {};

  const [archiveValue, setArchiveValue] = React.useState<string[]>([]);

  const handleArchiveChange = (event: any, values: string[]) => {
    setArchiveValue(values);
  };

  const maskRecordNumber = (recordNo: string) => {
    const length = recordNo.length;
    const maskedPart = '*'.repeat(length - 4);
    const lastFourDigits = recordNo.substring(length - 4);
    return maskedPart + lastFourDigits;
  };

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
        <Row>
          <Col className={'col-12 col-lg-12'}>
            <h2 className={'h2 text-sm-20-lg-24 mb-7 mb-lg-11'}>Case List</h2>
          </Col>
        </Row>
       
        <form noValidate={true}>
          <Row className="mt-8">
          <Col className="col-12 col-lg-7 p-2">
          <h5 className="text-sm-20-lg-24">View Case <span className="text-fs-6 fw-light">(Only one option at a time)</span></h5>
          <Row className="mt-4">
            <Col className="col-12 p-1">
              <Controller
                name={'Name'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="Name"
                    isInvalid={!!errors.Name}
                    {...field}
                  />
                )}
              />
              {errors.Name && (
                <div className="error-message">
                  <span>{errors.Name.message}</span>
                </div>
              )}
            </Col>
            <Col className="col-12 p-1">
              <Controller
                name={'SSN'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="SSN"
                    isInvalid={!!errors.SSN}
                    {...field}
                  />
                )}
              />
              {errors.SSN && (
                <div className="error-message">
                  <span>{errors.SSN.message}</span>
                </div>
              )}
            </Col>
            <Col className="col-12 p-1">
              <Controller
                name={'EID'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="EID"
                    isInvalid={!!errors.EID}
                    {...field}
                  />
                )}
              />
              {errors.EID && (
                <div className="error-message">
                  <span>{errors.EID.message}</span>
                </div>
              )}
            </Col>
 
            <Col className="col-12 p-1">
              <Controller
                name={'AccessID'}
                control={control}
                render={({ field }) => (
                  <TextInput
                    placeholder="Access ID"
                    isInvalid={!!errors.AccessID}
                    {...field}
                  />
                )}
              />
              {errors.Name && (
                <div className="error-message">
                  <span>{errors.AccessID.message}</span>
                </div>
              )}
            </Col>
            <Col className="col-12 p-1">
              <Controller
                name={'Inbox'}
                control={control}
                render={({ field }) => (
                  <Select
                    placeholder="Inbox"
                    options={inboxOptions}
                    {...field}
                    isInvalid={!!errors.Inbox}
                  />
                )}
              />
              {errors.SSN && (
                <div className="error-message">
                  <span>{errors.Inbox.message}</span>
                </div>
              )}
            </Col>
            <Col className="col-12"></Col>
          </Row>
          <Row className="mt-8">
            <Col className="col-12 p-1">
              <h5 className="text-sm-20-lg-24">
                Include <span className="text-fs-6 fw-light">(optional)</span>
              </h5>
            </Col>
          </Row>
          <Row className="mt-8">
            <Col className="col-12 p-1">
              <CheckboxGroup
                name={'with-labels'}
                value={archiveValue}
                onChange={handleArchiveChange}
              >
                <Checkbox
                  value={'archived'}
                  id={'2'}
                  label={'Archived Cases'}
                />
                <Checkbox
                  value={'closed'}
                  id={'3'}
                  label={'Closed Cases'}
                  className={'ms-2'}
                />
              </CheckboxGroup>
             </Col>
           </Row>
          </Col>
        
        <Col className="col-12 col-lg-5 p-1">
        <Row className={'m-0 p-0'}>
        <h5 className="text-sm-20-lg-24">At Your Fingertips</h5>
          <Col>
          <Container className="mt-3 p-10 border border-info rounded-1 col-lg-12">
              <Link rightIcon={light('chevron-right')}
                      className={'border-bottom py-4 '}
                      href="#/participant-access"
                      isAlignAtEnd >
                        <h6 className="text-fs-6 mb-0 fw-normal">Participant Access</h6>
              </Link>
              <Link rightIcon={light('chevron-right')}
                      href="#/participant-access"
                      isAlignAtEnd >
                        <h6 className="text-fs-6 mb-0 fw-normal">Document Search</h6>
              </Link>
            </Container>
          </Col>
        </Row>
        </Col>
        </Row>
          <section className="py-11 py-lg-12 d-flex flex-column flex-lg-row">
            <Button
              className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1 reset-button"
              variant="primary-outline"
              type="button"
              onMouseDown={handleResetButtonClick}
            >
              Reset
            </Button>
            <Button
              variant="primary"
              className="order-1 order-lg-2 search-button"
              type="button"
              onMouseDown={handleSearchButtonClick}
            >
              Search
            </Button>
          </section>
        </form>
        {isSearchResultVisible && (
          <div>
            <section
              className={'w-100 d-flex justify-content-between mt-7 add-case'}
            >
              <div className={'d-flex align-items-center'}></div>
              <div className={'d-none d-lg-block'}>
                <Button
                  size={'sm'}
                  rightIcon={light('circle-plus')}
                  onMouseDown={handleAddNewCaseShow}
                >
                  Add new
                </Button>
                <CaseFormModal
                  showModal={showAddNewCaseModal}
                  handleClose={handleAddNewCaseClose}
                  handleSubmit={handleSubmitCase}
                />
              </div>
            </section>
            <GenericCard
              variant={'white'}
              className={'mt-5 case-search-result'}
            >
              <Container className={'px-0 py-0'}>
                {/* Table head */}
                <Row className={'d-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px'}>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Date</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Record</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Plan</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>
                      Participant
                    </div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Inbox</div>
                  </Col>
                  <Col lg={2}>
                    <div className={'d-flex align-items-center'}>Details</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Doc</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}>Status</div>
                  </Col>
                  <Col lg={1}>
                    <div className={'d-flex align-items-center'}></div>
                  </Col>
                </Row>
                {/* Table body */}
                {filteredCaseList && filteredCaseList.map((caseItem, index) => (
                    <Row
                      key={caseItem.id}
                      className={
                        'my-5 pb-5 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                      }
                    >
                      <Col lg={1}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Date: 
                          </h2>
                          {caseItem.date}
                        </div>
                      </Col>
                      <Col lg={1}>
                        <div className={'d-flex align-items-center'}>
                           <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Record: 
                          </h2>
                          {maskRecordNumber(caseItem.recordNo)}
                        </div>
                      </Col>
                      <Col lg={1}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Plan: 
                          </h2>                         
                      
                          {caseItem.plan}
                        </div>
                      </Col>
                      <Col lg={2}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Participant: 
                          </h2>
                          {caseItem.participant}
                        </div>
                      </Col>
                      <Col lg={2}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Inbox: 
                          </h2>  
                          {caseItem.inbox}
                        </div>
                      </Col>
                      <Col lg={2}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Details: 
                          </h2>
                          {caseItem.details}
                        </div>
                      </Col>
                      <Col lg={1}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Doc: 
                          </h2>
                          {caseItem.doc}
                        </div>
                      </Col>
                      <Col lg={1}>
                        <div className={'d-flex align-items-center'}>
                        <h2
                            className={
                              'd-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8 px-3'
                            }
                          >
                            Status: 
                          </h2>
                          {caseItem.recordStatus}
                        </div>
                      </Col>
                      <Col lg={1}>
                        <div className={'d-flex align-items-center px-3'}>
                          <PopoverWithLinks
                            linksData={[
                              {
                                linkHeader: 'Comment',
                                route: `comment-case`,
                                icon: light('comment-dots'),
                                rightIcon: light('chevron-right'),
                                modal: true,
                                params: {
                                  caseId: caseItem.id,
                                },
                              },
                              {
                                linkHeader: 'View',
                                route: `view-case`,
                                icon: light('eye'),
                                rightIcon: light('chevron-right'),
                                modal: true,
                                params: {
                                  caseId: caseItem.id,
                                },
                              },
                            ]}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
              </Container>
            </GenericCard>
          </div>
        )}
      </Container>
    </Container>
  );
};

export default CaseList